/**
 * 申请表打印
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//申请表打印
import ApplicationPrint from './ApplicationPrint';
import { global_data } from '../../ui/auth'

class ApplicationPrintIndex extends React.Component {

    columns = [{
        title: '申请单编号',
        dataIndex: 'applicationId',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '10%',
    }, {
        title: '新车主',
        dataIndex: 'buyerName',
        width: '10%',
    }, {
        title: '旧车主',
        dataIndex: 'sellerName',
        width: '10%',
    }, {
        title: '提交人',
        dataIndex: 'applicantName',
        width: '7%',
    }, {
        title: '申请时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '11%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("APPLICATION_PRINT_PRINT")?
                <Tooltip title="打印申请表">
                    <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.printApplication.bind(this, record.applicationId)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        printVisible: false,
        printData: {},
        queryData: {},
        detailVisible: false,
        detailData: {},

        editData: {},
        visible: false,

        showLoding: false
    };

  
    //打印申请表
    printApplication = (info, e) => {
        this.setState({ printVisible: true });
        http.post({
            url: '/environment/findPrintApplicationInfo',
            data: { applicationId: info },
            success: (res) => {
                this.setState({ printData: res });
            }
        });
    }
    hiddenModalPrint = () => {
        this.setState({ printVisible: false });
    }
  
    //查询条件
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch.bind(this, "queryString")}
                                    enterButton
                                    style={{ width: '300px', marginRight: '10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId" url="/environment/findApplicationPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ApplicationPrint
                    visible={this.state.printVisible}
                    onCancel={this.hiddenModalPrint.bind(this)}
                    printData={this.state.printData}
                />
            </div>
        )
    }
}

export default ApplicationPrintIndex;